"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FileStatus;
(function (FileStatus) {
    FileStatus[FileStatus["Unknown"] = 0] = "Unknown";
    FileStatus[FileStatus["InProgress"] = 1] = "InProgress";
    FileStatus[FileStatus["Success"] = 2] = "Success";
    FileStatus[FileStatus["Error"] = 3] = "Error";
})(FileStatus || (FileStatus = {}));
exports.default = FileStatus;
//# sourceMappingURL=FileStatus.js.map